import GenericPage from '../page-generic';
import image from '../../assets/FaRegClock.svg';

export default function UnavailablePage() {
	return (
		<GenericPage
			title={'Kiosk Temporarily Unavailable'}
			message={'We apologize for the inconvenience.'}
			imageSrc={image}
			imageAlt={'Unavailable'}
		/>
	);
}
